<template>
  <div
    :style="{
      '--background-color': slide.backgroundColor?.hex,
      '--background-color-mobile': slide.backgroundColorMobile?.hex,
    }"
    class="relative flex h-full flex-col bg-[var(--background-color-mobile)] px-4 py-8 lg:bg-[var(--background-color)]"
  >
    <component
      :is="slide?.buttonUrl ? NuxtLink : 'div'"
      :to="slide?.buttonUrl ? localePath(slide.buttonUrl) : undefined"
      class="mb-6 block h-62 w-full cursor-pointer"
      :style="{
        filter: `brightness(${imageBrightnessFilter || 100}%)`,
      }"
    >
      <UiLazyImg
        class="h-full w-full"
        :src="slide.file?.url || '/images/no-image.webp'"
        :src-mobile="slide.fileMobile?.url || ''"
        :alt="slide.file?.alt || slide.title || 'image'"
        img-classes="object-cover"
      />
    </component>
    <div class="flex-auto" @click="contentLink" v-html="slide.text" />
  </div>
</template>

<script setup lang="ts">
import { NuxtLink } from "#components";
import { BlockSliderSlide } from "~/types/api/block.types";

defineProps<{
  slide: BlockSliderSlide;
  imageBrightnessFilter?: string;
}>();

const localePath = useLocalePathPolyfill();

const contentLink = useContentLink;
</script>
